import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import { classNames } from "Utils/utils";
import {
  VERTEX360_COPILOT_DEFAULT_MODULE_TAB_ID,
  VERTEX360_COPILOT_MODULE_PROMPTS,
  VERTEX360_COPILOT_WELCOME,
} from "../constants/vertex360CopilotConstants";
import {
  resolveCopilotModuleFromPathname,
  setCopilotEmptyStateModuleTab,
} from "../utils/vertex360CopilotModuleUtils";
import { VERTEX360_COPILOT_THEME } from "../constants/vertex360CopilotTheme";
import ModulePromptTabs from "./ModulePromptTabs";
import SuggestedPrompts from "./SuggestedPrompts";

const EmptyConversation = ({ onSelectPrompt, disabled = false }) => {
  const [activeTabId, setActiveTabId] = useState(() => {
    const fromPath = resolveCopilotModuleFromPathname(window.location.pathname);
    if (fromPath && VERTEX360_COPILOT_MODULE_PROMPTS[fromPath]) {
      return fromPath;
    }
    return VERTEX360_COPILOT_DEFAULT_MODULE_TAB_ID;
  });

  useEffect(() => {
    setCopilotEmptyStateModuleTab(activeTabId);
  }, [activeTabId]);

  const handleTabChange = (tabId) => {
    setActiveTabId(tabId);
    setCopilotEmptyStateModuleTab(tabId);
  };

  const activePrompts = useMemo(
    () => VERTEX360_COPILOT_MODULE_PROMPTS[activeTabId] ?? [],
    [activeTabId]
  );

  return (
    <div className="flex min-h-full flex-col justify-start gap-5 px-0.5">
      <div className="text-center">
        <div
          className={classNames(
            "mx-auto mb-3.5 flex h-11 w-11 items-center justify-center rounded-2xl text-white shadow-md shadow-[#4B6CB7]/25",
            VERTEX360_COPILOT_THEME.heroGradient
          )}
        >
          <HiOutlineSparkles className="h-5 w-5" />
        </div>
        <h3 className="text-[16px] font-bold tracking-tight text-slate-900">
          {VERTEX360_COPILOT_WELCOME.title}
        </h3>
        <p className="mx-auto mt-1.5 max-w-[340px] text-[12.5px] leading-relaxed text-slate-500">
          {VERTEX360_COPILOT_WELCOME.subtitle}
        </p>
      </div>

      <div className="space-y-3.5">
        <ModulePromptTabs
          activeTabId={activeTabId}
          onTabChange={handleTabChange}
        />
        <div className="copilot-module-prompts-panel">
          <SuggestedPrompts
            key={activeTabId}
            prompts={activePrompts}
            moduleId={activeTabId}
            onSelect={onSelectPrompt}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default EmptyConversation;
